import { z } from 'zod';

export const subscriptionCreateDtoSchema = z.object({
  email: z.string().email().describe('Email address'),
});

export class SubscriptionCreateDto {}
export interface SubscriptionCreateDto extends z.input<typeof subscriptionCreateDtoSchema> {}
